import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const AnalyticsComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__analytics"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_2440_17257)">
        <path
          d="M12.6667 7.39394C12.6667 10.3395 10.2789 12.7273 7.33333 12.7273C4.38781 12.7273 2 10.3395 2 7.39394C2 4.44842 4.38781 2.06061 7.33333 2.06061C8.14028 2.06061 8.90536 2.23982 9.59096 2.56061"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 14.0606L11.1 11.1606"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 10.0606L6 7.06061L7.5 8.56061L14.5 1.56061"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2440_17257">
          <rect width="16" height="16" fill="white" transform="translate(0 0.0606079)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Analytics = withIcon(AnalyticsComponent);
